import { NavLink } from 'react-router-dom'

// styles
import './Components.css'
import { userStore } from '../store/Store'

export default function SettingsSidebar() {
    // global 
    const currentUser = userStore(data => data.currentUser)
    const currentCompany = userStore(data => data.currentCompany)

    return (
        <div className='settings-sidebar'>
            <div className='sidebar-content'>
                <nav className='links'>
                    <ul>
                        {currentCompany.full_access && <li>
                            <NavLink to='/settings/companies'>
                                <span>Companies</span>
                            </NavLink>
                        </li>}
                        {currentCompany.full_access && <li>
                            <NavLink to='/settings/asset-rate-sheets'>
                                <span>Asset Rate Sheets</span>
                            </NavLink>
                        </li>}
                        {currentCompany.full_access && <li>
                            <NavLink to='/settings/rate-sheets'>
                                <span>Freight Rate Sheets</span>
                            </NavLink>
                        </li>}
                        {currentCompany.full_access && <li>
                            <NavLink to='/settings/fuel-surcharge'>
                                <span>Fuel Surcharge</span>
                            </NavLink>
                        </li>}
                        <li>
                            <NavLink to='/settings/users'>
                                <span>Users</span>
                            </NavLink>
                        </li>
                        {((currentUser.role_name === 'Account Admin' || currentUser.role_name === 'Systems Admin') && currentCompany.full_access) && 
                            <li>
                                <NavLink to='/settings/company-settings' end>
                                    <span>Company Settings</span>
                                </NavLink>
                            </li>
                        }
                    </ul>
                </nav>
            </div>
        </div>
    )
}
